// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1Rwb5","content":"styles_content__-jDXt","checkbox":"styles_checkbox__3j9lj","checkboxLabel":"styles_checkboxLabel__2NBP_"};